// DEPLOY: /var/www/woody.wtf/frontend/src/components/ImpactTags.js
// Small tags for an announcement's AI expected move, surprise, positioning and financing risk
// (market.announcements.expected_move / surprise / positioning / financing_risk, written by
// analyse_announcements.py):
// "10-20%" - the move expected on the news alone, either direction, from the last price before
// release to that session's close (pre/post-market and auction included); the surprise against
// what was expected (MUCH BETTER ... MUCH WORSE); from 30 Oct 2026 the positioning - what the
// price already assumed (PRICED IN / PARTLY PRICED IN / NOT PRICED IN / PRICED FOR THE OPPOSITE,
// the last two stand out: that is where the big moves come from) - and the financing risk
// (RAISE POSSIBLE / RAISE LIKELY / RAISING; 'none' shows nothing). Shown after the novelty tag
// on the Company, Announcements, AI Audit and Discord Bot pages, styled like NoveltyTag.
// Renders nothing for summaries written before these existed.
import React from 'react';

const BIG_MOVES = ['10-20', '20-50', '50+'];
const SURPRISE = {
  'much better': { color: 'var(--success)', background: 'var(--success-dim)', borderColor: 'var(--success)', fontWeight: 600 },
  'better':      { color: 'var(--success)' },
  'as expected': { opacity: 0.7 },
  'worse':       { color: 'var(--error)' },
  'much worse':  { color: 'var(--error)', background: 'var(--error-dim)', borderColor: 'var(--error)', fontWeight: 600 },
};

const POSITIONING = {
  'priced in':               { opacity: 0.7 },
  'partly priced in':        {},
  'not priced in':           { borderColor: 'var(--accent)', color: 'var(--accent)', fontWeight: 600 },
  'priced for the opposite': { borderColor: 'var(--accent)', color: 'var(--accent)', fontWeight: 600 },
};
const FINANCING = {
  possible: { label: 'RAISE POSSIBLE', style: { color: 'var(--warning)' } },
  likely:   { label: 'RAISE LIKELY',   style: { color: 'var(--error)', fontWeight: 600 } },
  raising:  { label: 'RAISING',        style: { color: 'var(--error)', background: 'var(--error-dim)', borderColor: 'var(--error)', fontWeight: 600 } },
};

const base = {
  display: 'inline-block', marginLeft: '6px', verticalAlign: 'middle', whiteSpace: 'nowrap',
  fontFamily: "'JetBrains Mono', monospace", fontSize: '9px', letterSpacing: '0.06em', lineHeight: 1.4,
  padding: '0 5px', borderRadius: 'var(--radius)', border: '1px solid var(--border)', color: 'var(--text-muted)',
};

export default function ImpactTags({ move, surprise, basis, positioning, positioningBasis, financing }) {
  return (
    <>
      {move && (
        <span style={{ ...base, ...(BIG_MOVES.includes(move) ? { borderColor: 'var(--accent)', color: 'var(--accent)', fontWeight: 600 } : {}) }}
              title="Expected total reaction to this news, either direction - last price before release to the close of the first session after it, pre/post-market and opening auction included">
          {move}%
        </span>
      )}
      {SURPRISE[surprise] && (
        <span style={{ ...base, ...SURPRISE[surprise] }} title={basis ? `Expected: ${basis}` : 'Against what was expected before release'}>
          {surprise.toUpperCase()}
        </span>
      )}
      {POSITIONING[positioning] && (
        <span style={{ ...base, ...POSITIONING[positioning] }}
              title={positioningBasis ? `What the price already assumed: ${positioningBasis}` : 'What the share price already assumed before this release'}>
          {positioning.toUpperCase()}
        </span>
      )}
      {FINANCING[financing] && (
        <span style={{ ...base, ...FINANCING[financing].style }} title="Likely to need new equity soon, judged from cash, burn and commitments">
          {FINANCING[financing].label}
        </span>
      )}
    </>
  );
}
